/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import viewicoSvg from '../../../../public/view-product.svg';
import editicoSvg from '../../../../public/edit-product.svg';
import ProductService from '../../../../services/ProductService';
import moment from "moment";
import { showLoading } from 'react-global-loading';

import plsprd from '../../../../public/adprdc.svg';

export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';
class PractitionersProducts extends React.Component {
  constructor(props) {
    showLoading(false);
    super(props);
    this.state = {
      productsList: [],
    };
  }

  componentDidMount = () => { this.getProductList(); };

  getProductList = () => {
    ProductService.fetchProductsByBlog({ 'blog_id': userData.blog_id.userblog_id })
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({ productsList: result });
        showLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  render() {
    const { productsList } = this.state;

    return (
      <div className="container pt-2">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">Practitioner's Products</li>
          </ol>
        </nav>
        <div className="prlsthead mt-5 mb-3 rounded rounded-2">
          <div className=" head-title">
            <h4 className="myprdhh">My Products</h4>
            <p>You can view / Add / Edit your products registered with the Ayush Global Portal
            </p>
          </div>
          <div className=" d-flex align-items-center justify-content-center">
            <Link to="/add-practitioner-products" className="card-link rounded rounded-2 w-100 btntxdsh darkbtn">
              {/* <img src={plsprd} className="mx-1" alt="view and edit events" /> */}
              {/* <i className="fa fa-plus-circle" aria-hidden="true"></i> */}
              Add New Product
            </Link>
          </div>
          {/* <hr></hr> */}
          {/* <div className="col-12">
            <div className="row">
              <span className="text-secondary d-block mb-2">
                <i className="fa fa-filter" aria-hidden="true" /> Filter Products
              </span>
              <div className="col-4">
                <div className="form-group mb-4 position-relative has-search">
                  <span className="fa fa-search form-search"></span>
                  <input type="text" className="form-control pd-tb-675em" name="searchname" placeholder="Search By Name" />
                </div>
              </div>
              <div className="col-4">
                <div className="form-group mb-4 position-relative">
                  <label for="eventname" className="form-label over-label2">Date of Event</label>
                  <input type="text" className="form-control pd-tb-675em" name="eventdate" placeholder="mm/dd/yyyy" />
                </div>
              </div>
              <div className="col-4">
                <div className="form-group mb-4 position-relative">
                  <select className="form-select pd-tb-675em" aria-label="Search Domain">
                    <option value="" selected disabled>Search By Domain</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>
              </div>
            </div>
          </div> */}
        </div>
        <div className="row bg-light p-2 pt-4 mb-3 rounded rounded-2">
          {/* <div className="col-md-2 view-mode-btn text-end mb-3">
            <a href="#" className="btn" id="list2"> <i className="fa fa-list p-2 fs-4" aria-hidden="true"></i></a>
            <a href="#" className="btn active_btn2" id="grid2"> <i className="fa fa-th p-2 fs-4" aria-hidden="true"></i></a>
          </div> */}
          <div className="col-12">
            <div className="row view-group" id="products2">

              {/* below is the product card */}
              {productsList.map((item, index) =>
                <div key={index} className="col-lg-3 col-md-6 col-xs-12 mb-3" >
                  <div className="card p-3 event-card crdev">
                    <div className="imgrel">
                      <Link to={{
                        pathname: "/product-practitioner-details",
                        search: `?id=${item.ID}&blog=${userData.blog_id?.userblog_id}`,
                        state: { productDetails: item }
                      }}>  <img src={item.product_image[0]} className=" card-img-top rounded" alt="events" style={{
                        height: '150px', objectFit: 'cover'
                      }} /></Link>

                      <div className="card-img-overlay pazre">
                        <Link to={{
                          pathname: '/edit-practitioner-products',
                          search: `?id=${item.ID}&blog=${userData.blog_id?.userblog_id}`,
                          state: { productDetails: item }
                        }} className="btn d-block">
                          <img src={editicoSvg} alt="edit product" />
                        </Link>
                      </div>
                    </div>
                    <div className="evtxcn px-0 ">
                      <h4 className="evh">
                        < p className="evhd crop-text">{item.post_title}</p>
                      </h4>
                      <span className="muted d-block mt-1 doccell crop-text">{item.post_title}</span>
                      <p className="evdes_nw">{item.post_content} </p>
                    </div>
                  </div>
                  <div className="crbotm">
                    <p className="dtpr">Created - <span className="cdte">{moment(item.post_date).format("Do MMM YYYY")}</span></p>
                    <span className="dtpr">/</span>
                    <p className="dtpr">{` Last Updated On - `}<span className="cdte">{moment(item.post_modified).format("Do MMM YYYY")}</span></p>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default PractitionersProducts;